import React from 'react';

export default class Debug extends React.Component {

  render() {
    return <div></div>
  }

}